import { useState } from "react";
import { ChevronDownIcon, LightbulbIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

// Progressive hints. The server returns only the hints the member has already
// unlocked, so we render whatever arrives and hide the panel when none are.
export function HintsDisclosure({ hints }: { hints: string[] }) {
  const [open, setOpen] = useState(false);
  if (!hints || hints.length === 0) return null;

  return (
    <Card className="gap-0 overflow-hidden py-0">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center gap-2 px-5 py-3 text-left text-sm font-medium hover:bg-muted/50"
      >
        <LightbulbIcon className="size-4 text-amber-500" />
        Hints
        <ChevronDownIcon
          className={cn(
            "ml-auto size-4 text-muted-foreground transition-transform",
            open && "rotate-180"
          )}
        />
      </button>
      {open && (
        <div className="space-y-3 border-t px-5 py-4">
          {hints.map((hint, i) => (
            <div key={i} className="text-sm leading-relaxed break-words">
              <p className="mb-0.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Hint {i + 1}
              </p>
              <p>{hint}</p>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
